import { OneDriveFile, OneDrivePackage } from 'owa-fileprovider-services';
import { OneDriveOneNoteType, OneNoteMimeType } from '../constants';

export function getMimeTypeForOneDriveItem(item: {
    file?: OneDriveFile;
    package?: OneDrivePackage;
}): string {
    if (item.file) {
        return item.file.mimeType;
    } else if (item.package && item.package.type === OneDriveOneNoteType) {
        // Client side calls do not return mimetypes for OneNote, so we check the package type.
        return OneNoteMimeType;
    } else {
        return null;
    }
}
